import { useEffect, useMemo, useState } from "react";
import { ADMIN_LIST_PAGE_SIZE } from "../api.ts";

/**
 * 前端切片分页：API 仍可一次返回全量（配置类小表），UI 固定每页 pageSize（默认 30）。
 * resetKey 变化时回到第 1 页（筛选/搜索）。
 */
export function useClientPagination<T>(
  items: ReadonlyArray<T>,
  resetKey: unknown = "",
  pageSize: number = ADMIN_LIST_PAGE_SIZE,
): {
  readonly page: number;
  readonly setPage: (page: number) => void;
  readonly pageSize: number;
  readonly total: number;
  readonly totalPages: number;
  readonly pageItems: ReadonlyArray<T>;
} {
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [resetKey, pageSize]);

  const total = items.length;
  const totalPages = total === 0 ? 0 : Math.ceil(total / pageSize);
  const safePage = totalPages === 0 ? 1 : Math.min(Math.max(1, page), totalPages);

  const pageItems = useMemo(
    () => items.slice((safePage - 1) * pageSize, safePage * pageSize),
    [items, safePage, pageSize],
  );

  return {
    page: safePage,
    setPage,
    pageSize,
    total,
    totalPages,
    pageItems,
  };
}
